import React, {createContext, useState} from "react";
import useListContext from "../../tools/useListContext";
import {useModal} from "../../tools/useModal";
import {DeviceServiceRepository, ServiceModalData} from "../../repository/AdminDashboard/DeviceServisce_Repository";
import {DeviceListRepository} from "../../repository/AdminDashboard/DeviceList_Repository";
import toast from "react-hot-toast";
import useDebounce from "../../tools/useDebounce";

const ServiceContext = createContext();

export function ServiceProvider({children}) {
    const {
        handleUpdateListState, listState, onDevicePerPageChange, changePage, onSearchBtnClick,
    } = useListContext(getServices)

    const {closeModal, openModal, modalState} = useModal();

    const [addEditServiceState, setAddEditServiceState] = useState({
        "searchSerialNumber": [], "enteredSerialNumber": "", "searchLoading": false
    })


    async function getServices() {

        handleUpdateListState("loading", true)
        const response = await DeviceServiceRepository.getList(
            listState.searchQuery,
            listState.pageNumber,
        );
        handleUpdateListState("loading", false)

        if (response.code !== 1) {
            toast.error(response.massage, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        console.log("RESPONSE : ", response)
        handleUpdateListState("list", response.List_data)
        handleUpdateListState("countAll", response.countAllPages)
    }

    const updateServiceData = (key, value) => {
        setAddEditServiceState(prev => ({...prev, [key]: value}));

    }

    async function searchSerialNumberRequest(query) {

        const response = await ServiceModalData.getserialnumber(query);
        updateServiceData("searchSerialNumber", response.serialN);


    }

    async function searchSerialNumber(props) {

        if (props.state.search.length > 2 && addEditServiceState.enteredSerialNumber !== props.state.search) {
            updateServiceData("searchLoading", true)
            updateServiceData("enteredSerialNumber", props.state.search)
        }

    }

    async function serviceModalCallback(data) {
        let response;
        if (modalState.mode === "add") {
            const body = {
                "nameOwner": data.name,
                "serialNumber": data.serialNumber,
                "serviceType": data.serviceType,
                "text": data.description
            }
            response = await ServiceModalData.addservice(body)
        } else {
            const body = {
                "id": data.id,
                "serviceType": data.serviceType,
                "text": data.description
            }
            response = await ServiceModalData.editservice(body)
        }

        if (!response.success) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            })
            return;
        }
        toast.success(response.message, {
            className: "text-12 text-dark-blue-200",
        });
        await getServices();

        closeModal()

    }

    async function onEditServiceBtnClick(data) {
        const response = await ServiceModalData.getDetail(data.id)
        if (response.success) {
            openModal("edit", response.data.detail)


        }
    }

    async function deleteServiceClick() {

        const response = await DeviceServiceRepository.delete(modalState.selectedItem.id);
        if (!response.success) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            })
            return;
        }
        toast.success(response.message, {
            className: "text-12 text-dark-blue-200",
        });
        await getServices();

        closeModal()
    }

    useDebounce(
        async () => {
            await searchSerialNumberRequest(addEditServiceState.enteredSerialNumber)
            updateServiceData("searchLoading", false)
        },
        2000,
        [addEditServiceState.enteredSerialNumber]
    );

    return (<ServiceContext.Provider value={{
        handleUpdateListState,
        onEditServiceBtnClick,
        addEditServiceState,
        serviceModalCallback,
        deleteServiceClick,
        searchSerialNumber,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick,
        closeModal,
        openModal,
        modalState


    }}>

        {children}
    </ServiceContext.Provider>)
}

export function useServiceContext() {
    return React.useContext(ServiceContext)

}